// src/components/common/ProfileHeader.tsx
import useAppAuthStore from '@/shared/store/UseAppAuthStore';
import React, { useEffect, useState } from 'react';
import ImgHeaderLevel from '@/assets/app/images/common/header/header-level.png';
import ImgHeaderStar from '@/assets/app/images/common/header/header-star.png';
import ImgHeaderCalendar from '@/assets/app/images/common/header/header-calendar.png';
import ImgModifyBtn from '@/assets/app/images/common/header/modify_btn.png';
import { getBackEndUrl, getUploadsUrl, openUpdateNicknameSheet } from '@/shared/utils/CommonUtil';
import defaultPersonImage from '@/assets/app/images/common/default-person.svg';
import { useLocation, useNavigate } from 'react-router';

/**
 * 상단 프로필 헤더 (공통 컴포넌트)
 * - 프로필 이미지, 닉네임, 레벨, 별, 출석일수 표시
 * - Tailwind CSS 사용
 */
const ProfileHeader: React.FC = () => {
  const { checkAttendance, member } = useAppAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const pathsWithProfile = ['/main'];
  const showSpecialArea = pathsWithProfile.some(path => location.pathname.includes(path));

  useEffect(() => {
    checkAttendance();
  }, []);

  if (!member) return null;

  return (
    <div
      className={`${showSpecialArea ? `bg-[#0094EF]` : ''} p-4 relative f-one-pop`}
      style={
        showSpecialArea ? { borderBottom: '5px solid #0070D6', borderRadius: '0 0 25px 25px' } : {}
      }
    >
      {/* 프로필 섹션 */}
      {showSpecialArea && (
        <div className="flex items-center mb-4">
          <img
            src={
              member.profileImageFilename
                ? `${getUploadsUrl()}/character/${member.profileImageFilename}`
                : defaultPersonImage
            }
            alt={member.nickname}
            className="w-18 h-18 rounded-full border-4 border-[#0066B2] mr-3"
          />{' '}
          <div className="w-full" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'column', color: '#fff' }}>
              <span className="text-xl font-bold font-[800]">{member.nickname}</span>
              <span>가입일: {new Date(member?.createdAt || '').toLocaleDateString('ko-KR')}</span>
            </div>
            <div>
              <img src={ImgModifyBtn} className="w-[70px]" onClick={openUpdateNicknameSheet} />
            </div>
          </div>
        </div>
      )}

      {/* 통계 섹션 */}
      <div className="user-status-board">
        {/* 레벨 */}
        <div className="status-item" onClick={() => navigate('/mypage/level')}>
          <img src={ImgHeaderLevel} alt="level" className="status-icon" />
          <div className="status-text level">
            <span className="status-label">Lv.</span>
            <span className="status-value">{member.level}</span>
          </div>
        </div>

        {/* 별 */}
        <div className="status-item" onClick={() => navigate('/record')}>
          <img src={ImgHeaderStar} alt="star" className="status-icon" />
          <div className="status-text star">
            <span className="status-value">{member.totalPoints}</span>
          </div>
        </div>

        {/* 캘린더 */}
        <div className="status-item">
          <img src={ImgHeaderCalendar} alt="calendar" className="status-icon" />
          <div className="status-text calendar">
            <span className="status-value" style={{ color: '#E1464D', fontSize: 16 }}>
              {member.consecutiveDays}
            </span>
            <span className="status-unit">일차</span>
          </div>
        </div>
      </div>

      {!showSpecialArea && (
        <div className="absolute bottom-0 left-0 right-0 mx-3 border-b border-gray-200" />
      )}
    </div>
  );
};

export default ProfileHeader;
